import { CreatePageLayout } from 'framework/ui/layout';
import { CreateForm } from 'framework/form';
import { useProjectId } from 'domain/shared/project';
import { useNewProjectUrl, useProjectTeamService } from 'domain/shared/newProject';
import CriticalPeriodForm from './CriticalPeriodForm';
import { Box } from '@mui/material';
import { useMessageService, ErrorMessage } from 'framework/ui/Message';

const CreateCriticalPeriodLayout = () => {
  const { getCriticalPeriodsValidationSchema, createCriticalPeriod } = useProjectTeamService();
  const id = useProjectId();
  const { getProjectTeamUrl } = useNewProjectUrl();
  const { addMessage } = useMessageService();

  return (
    <CreateForm
      submitFormFunc={async values => {
        const response = await createCriticalPeriod(id, values);

        if (response?.message) {
          addMessage(new ErrorMessage(response.message));
          return { error: response.message };
        }

        return { result: response };
      }}
      afterSubmit={{
        redirect: getProjectTeamUrl(id),
        message: 'You are awesome! Critical period has been successfully created.',
      }}
      getDataFunc={() => Promise.resolve()}
      getValidationSchemaFunc={getCriticalPeriodsValidationSchema}
    >
      <Box sx={{ '& .show-page__content-inner': { minHeight: '20vh !important' } }}>
        <CreatePageLayout isCancelButtonVisible={false} title="Create Critical Period:" buttons={<></>}>
          <CriticalPeriodForm />
        </CreatePageLayout>
      </Box>
    </CreateForm>
  );
};

export default CreateCriticalPeriodLayout;
